import React from 'react'
import { CheckIcon } from '@heroicons/react/20/solid'

export interface StepItemProps {
    name: string
    href: string
    status: 'todo' | 'current' | 'complete'
    index: number
}

export function StepItem({ name, href, status, index }: StepItemProps) {
    const lineClass =
        status === 'complete' ? 'bg-neutral-700' : 'bg-neutral-200'
    const circleClass =
        status === 'complete'
            ? 'bg-neutral-700 border-neutral-700 hover:bg-black hover:border-black cursor-pointer'
            : status === 'current'
            ? 'border-neutral-700 cursor-default'
            : 'border-neutral-200 cursor-default'
    const textClass =
        status === 'current' ? 'text-neutral-700' : 'text-neutral-200'
    return (
        <>
            <div
                className="absolute inset-0 flex items-center"
                aria-hidden="true"
            >
                <div className={`h-0.5 w-full ${lineClass}`} />
            </div>
            <a
                href={href}
                className={`relative flex h-12 w-12 items-center justify-center rounded-full border-2 bg-white ${circleClass}`}
            >
                {status === 'complete' ? (
                    <CheckIcon
                        className="h-8 w-8 text-white"
                        aria-hidden="true"
                    />
                ) : (
                    <span
                        className={`border-none text-2xl ${circleClass} ${textClass}`}
                    >
                        {index}
                    </span>
                )}

                <span
                    className={`absolute left-[50%] top-14 min-w-max translate-x-[-50%] text-center text-xs uppercase`}
                >
                    {name}
                </span>
            </a>
        </>
    )
}
